{{ 'Conversation::ListCreationFailedMessage' | abpLocalization }}
